import React, { createContext, useContext, useEffect, useState } from "react";
import { jwtHandler } from "../../../../services/Handlers";

const GlobalContext = createContext();

export const GlobalContextProvider = ({ children }) => {

  const defaultUsuaio = {
    isAdmin: false,
    username: ''
  }

  const [showSpinner, setShowSpinner] = useState(false);
  const [usuario, setUsuario] = useState(defaultUsuaio);

  const isAdmin = () => {
    const token = jwtHandler(localStorage.getItem("token"))
    if (token) {
      if (token.authorities.some((i) => i === "ecovidaSellerAdmin")) {
        setUsuario((prev) => ({
          ...prev,
          isAdmin: true,
          username: token.user_name
        }))
      } else {
        setUsuario((prev) => ({
          ...prev,
          isAdmin: false,
          username: token.user_name
        }))
      }
    }
  }

  useEffect(() => {
    isAdmin();
  }, [])

  const value = {
    showSpinner,
    setShowSpinner,
    usuario,
    setUsuario
  }

  return (
    <GlobalContext.Provider value={value}>
      {children}
    </GlobalContext.Provider>
  )
}

export const useGlobalContext = () => {
  const context = useContext(GlobalContext);
  if (!context) {
    throw new Error('useProductContext deve ser usado com um ProdutoProvider');
  }
  return context
}